module.exports = __webpack_public_path__ + "img/Calculatie software.279673ba.svg";